var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03784 2.10259C10.0487 1.28025 11.498 1.28025 12.5089 2.10259L12.9918 2.49545L13.6065 2.3967C14.8931 2.18997 16.1482 2.9146 16.6124 4.13221L16.8342 4.7139L17.416 4.93571C18.6335 5.4 19.3582 6.65508 19.1514 7.9417L19.0527 8.55636L19.4455 9.0393C20.268 10.0502 20.268 11.4994 19.4455 12.5103L19.0527 12.9933L19.1514 13.6079C19.3582 14.8945 18.6335 16.1497 17.416 16.6139L16.8342 16.8357L16.6124 17.4174C16.1482 18.635 14.8931 19.3597 13.6065 19.1529L12.9918 19.0541L12.5089 19.447C11.498 20.2694 10.0487 20.2694 9.03784 19.447L8.5549 19.0541L7.94024 19.1529C6.65362 19.3597 5.39853 18.635 4.93424 17.4174L4.71244 16.8357L4.13075 16.6139C2.91313 16.1497 2.18851 14.8945 2.39524 13.6079L2.49399 12.9933L2.10113 12.5103C1.27879 11.4994 1.27879 10.0502 2.10113 9.0393L2.49399 8.55636L2.39524 7.9417C2.18851 6.65508 2.91313 5.4 4.13075 4.93571L4.71244 4.7139L4.93424 4.13221C5.39853 2.9146 6.65362 2.18997 7.94024 2.3967L8.5549 2.49545L9.03784 2.10259Z",
    stroke: "#215250",
    strokeWidth: 1.79,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20312 14.3475L14.3485 7.20215",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91766 8.63122C8.31229 8.63122 8.6322 8.31131 8.6322 7.91668C8.6322 7.52206 8.31229 7.20215 7.91766 7.20215C7.52304 7.20215 7.20312 7.52206 7.20312 7.91668C7.20312 8.31131 7.52304 8.63122 7.91766 8.63122Z",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6286 14.3475C14.0232 14.3475 14.3431 14.0276 14.3431 13.633C14.3431 13.2384 14.0232 12.9185 13.6286 12.9185C13.234 12.9185 12.9141 13.2384 12.9141 13.633C12.9141 14.0276 13.234 14.3475 13.6286 14.3475Z",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.72daf981fb014bc6b0196262f59b1286.svg";
export { ForwardRef as ReactComponent };